import { handleGaClick, trackEventFromDataset } from './ga';
import type { NavPromoTile } from './types';

const tabs: Record<string, string> = {
  engagement: 'ENGAGEMENT RINGS',
  wedding: 'WEDDING RINGS',
  diamonds: 'DIAMONDS',
  gemstone: 'GEMSTONES',
  gifts: 'GIFTS',
  jewelry: 'JEWELRY',
  about: 'ABOUT',
};

function NavLinkDropdown({
  navLink,
  itemIndex,
  totalItems,
  onClick,
  promo,
  currencyCode,
  onPromoTermsClick,
  isGlobalEFlag = false,
  isGlobalESite = false,
}: {
  navLink: any;
  itemIndex: number;
  totalItems: number;
  onClick: () => void;
  promo: NavPromoTile;
  currencyCode?: string;
  onPromoTermsClick?: () => void;
  isGlobalEFlag?: boolean;
  isGlobalESite?: boolean;
}) {
  const topNav = promo;
  const currentCurrencyCode = currencyCode || '$';

  return (
    <div className="subnav-content dropdown-menu">
      <div className="wrapper container1170">
        <div
          className="row cn-row"
          style={itemIndex + 1 === totalItems ? { paddingLeft: '27%', paddingRight: '13%' } : {}}
        >
          {navLink?.itemMenu.submenu?.map((submenu: any, submenuIndex: number) => (
            <div
              key={submenuIndex}
              className={`desktop:tw-w-3/12 tw-px-[10px] subnav-item ${submenu?.categorybg ? 'categorybg' : ''}`}
            >
              {submenu?.submenuHeaders?.map((header: any, headerIndex: number) => (
                <div key={headerIndex}>
                  <div
                    className={`${header?.header?.isUseRomanStyle ? '' : 'h2 !tw-font-heavy'}`}
                    style={{ textTransform: 'none' }}
                  >
                    {header?.header?.url ? (
                      <a
                        href={header?.header?.url}
                        className="title-link"
                        data-text={header?.header.label}
                        onClick={e =>
                          handleGaClick(e, 'top_navigation_click', header?.header?.url, header?.header.label, 'top nav')
                        }
                        data-category={header?.header?.dataCategory}
                        data-action={header?.header?.dataAction}
                        data-label={header?.header?.dataLabel}
                      >
                        {header?.header.label}
                      </a>
                    ) : (
                      header?.header.label
                    )}
                  </div>
                  <ul className="nav">
                    {header?.header?.items?.map((headerItem: any, headerItemIndex: number) => (
                      <li key={headerItemIndex} className={headerItem?.isHalf ? 'li-half' : undefined}>
                        <a
                          href={headerItem?.url}
                          onClick={e => {
                            handleGaClick(e, 'top_navigation_click', headerItem?.url, headerItem?.label, 'top nav');
                          }}
                          data-category={headerItem?.dataCategory}
                          data-action={headerItem?.dataAction}
                          data-label={headerItem?.dataLabel}
                        >
                          {headerItem?.icon && <i className={headerItem?.icon} />}
                          {(isGlobalEFlag && !isGlobalESite) || !isGlobalEFlag
                            ? headerItem?.label.replace(/\$/g, currentCurrencyCode)
                            : headerItem?.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ))}
          {navLink?.itemMenu?.recommend && (
            <div className="desktop:tw-w-3/12 tw-px-[10px] recomment">
              <div className="subnav-three-ad">
                {!!topNav?.category && navLink.itemMenu.label === tabs[topNav?.category] ? (
                  <a
                    href={topNav?.img_link}
                    onClick={trackEventFromDataset}
                    className="js-top-nav-engagement-picture !tw-w-[194px]"
                    data-category={navLink?.itemMenu?.recommend?.dataCategory || 'Top Navigation'}
                    data-action={navLink?.itemMenu?.recommend?.dataAction || 'Click'}
                    data-label={navLink?.itemMenu?.recommend?.dataLabel || 'Feature Image'}
                    data-noninteract="false"
                    data-ge-hide=""
                  >
                    <div className="nav-promo">
                      <div className="nav-promo__img">
                        <img
                          loading="lazy"
                          src={topNav?.image?.url}
                          srcSet={`${topNav?.image['url_1.5x']} 1.5x, ${topNav?.image['url_2x']} 2x`}
                          alt={topNav?.image?.alt || ''}
                          className="img-responsive"
                          width="194"
                        />
                      </div>
                      <div
                        className="nav-promo__body middle"
                        style={{
                          minHeight: '117px',
                          boxSizing: 'border-box',
                          paddingTop: 0,
                          background: topNav?.background_hex_color,
                        }}
                      >
                        <div>
                          <div
                            className="nav-promo__header"
                            style={{ fontSize: topNav?.header['font-size'], color: topNav?.header.color }}
                          >
                            {topNav?.header?.text}
                          </div>
                          <div
                            className="nav-promo__subheader"
                            style={{ fontSize: topNav?.subheader['font-size'], color: topNav?.subheader?.color }}
                            dangerouslySetInnerHTML={{ __html: topNav?.subheader?.text || '' }}
                          />
                        </div>
                      </div>
                      <span
                        className="nav-promo__terms-apply"
                        style={{ fontSize: topNav?.t_c['font-size'], color: topNav?.t_c?.color }}
                        onClick={e => {
                          e.preventDefault();
                          onClick();
                          onPromoTermsClick?.();
                        }}
                        role="button"
                        tabIndex={0}
                        aria-label="Promo terms and conditions"
                        onKeyDown={event => {
                          if (event.key === 'Enter') {
                            onClick();
                            onPromoTermsClick?.();
                          }
                        }}
                        dangerouslySetInnerHTML={{ __html: topNav?.t_c?.text || '' }}
                      />
                    </div>
                  </a>
                ) : (
                  <a
                    href={navLink?.itemMenu?.recommend?.url}
                    onClick={trackEventFromDataset}
                    data-category={navLink?.itemMenu?.recommend?.dataCategory || 'Top Navigation'}
                    data-action={navLink?.itemMenu?.recommend?.dataAction || 'Click'}
                    data-label={navLink?.itemMenu?.recommend?.dataLabel || 'Feature Image'}
                    data-noninteract="false"
                  >
                    <img
                      loading="lazy"
                      src={navLink?.itemMenu?.recommend?.image}
                      alt={navLink?.itemMenu?.recommend?.alt || ''}
                      width={214}
                      height={250}
                      className="img-responsive"
                    />
                  </a>
                )}
              </div>
            </div>
          )}
        </div>
        {navLink?.itemMenu?.footer && (
          <div className="row cn-row">
            <div className="subnav-item subnav--natural-diamonds diamond-quiz-top" style={{ marginRight: '458.633px' }}>
              <ul className="nav">
                <li>
                  <a
                    href={navLink?.itemMenu?.footer?.url}
                    onClick={trackEventFromDataset}
                    className="tw-gap-x-2"
                    data-category="Top Navigation"
                    data-action="Click"
                    data-label="Diamonds:Diamond Quiz Text"
                    data-noninteract="true"
                  >
                    <img
                      loading="lazy"
                      src={navLink?.itemMenu?.footer?.image}
                      alt={navLink?.itemMenu?.footer?.alt || ''}
                      width="20"
                      className="mr5"
                    />
                    {navLink?.itemMenu?.footer?.label}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
      <div className="categorybgcolor" />
    </div>
  );
}

export default NavLinkDropdown;
